import { Options } from '@shared/ui/components/Select';

export type FrequentPassageRequestVehicleType =
  | 'car'
  | 'motorcycle'
  | 'minivan'
  | 'van'
  | 'single axe'
  | 'double axe'
  | 'exceptional transport';

export const frequentPassageRequestVehicleTypeOptions: Options<FrequentPassageRequestVehicleType> = [
  { value: 'car', label: 'Car' },
  { value: 'motorcycle', label: 'Motorcycle' },
  { value: 'minivan', label: 'Minivan' },
  { value: 'van', label: 'Van' },
  { value: 'single axe', label: 'Single Axe' },
  { value: 'double axe', label: 'Double Axe' },
  { value: 'exceptional transport', label: 'Exceptional Transport' },
];
